import { render, staticRenderFns } from "./videoPopup.vue?vue&type=template&id=9f35bc5c&scoped=true&"
import script from "./videoPopup.vue?vue&type=script&lang=js&"
export * from "./videoPopup.vue?vue&type=script&lang=js&"
import style0 from "./videoPopup.vue?vue&type=style&index=0&id=9f35bc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f35bc5c",
  null
  
)

export default component.exports